/* BV Goods - offer mechanics.
   Buy X get Y free. Injects live progress into the cart drawer and cart page
   without touching Horizon's own cart markup, so theme updates still apply. */
(function () {
  var CFG = window.bvOffer || {};
  var BUY = CFG.buy || 3;
  var GET = CFG.get || 1;
  var STEP = BUY + GET;               // items needed for one free item

  function money(cents) {
    try {
      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
      });
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  /* cheapest N unit prices across the cart, expanded by quantity */
  function cheapest(cart, n) {
    var units = [];
    (cart.items || []).forEach(function (i) {
      for (var q = 0; q < i.quantity; q++) units.push(i.final_price);
    });
    units.sort(function (a, b) { return a - b; });
    return units.slice(0, n).reduce(function (a, b) { return a + b; }, 0);
  }

  function render(cart) {
    var count = cart.item_count || 0;
    var earned = Math.floor(count / STEP) * GET;      // free items already qualified
    var into = count % STEP;                          // progress toward the next one
    var need = STEP - into;
    var qualified = earned > 0;
    var msg, saving = '';

    if (count === 0) {
      msg = 'Add ' + STEP + ' items and the cheapest is free.';
    } else if (!qualified) {
      msg = 'Add ' + need + ' more item' + (need > 1 ? 's' : '') + ' and get 1 free.';
    } else {
      msg = earned + ' free item' + (earned > 1 ? 's' : '') + ' applied at checkout.';
      var save = cheapest(cart, earned);
      if (save) saving = 'You save ' + money(save) + '.';
      if (need < STEP) {
        msg += ' Add ' + need + ' more for another.';
      }
    }

    var pct = qualified && into === 0 ? 100 : (into / STEP) * 100;

    document.querySelectorAll('[data-bv-bogo]').forEach(function (el) {
      el.className = 'bv-bogo' + (qualified ? ' bv-bogo--met' : '');
      el.innerHTML =
        '<div class="bv-bogo__bar"><span style="width:' + Math.min(100, pct) + '%"></span></div>' +
        '<p class="bv-bogo__msg">' + msg + (saving ? ' <b>' + saving + '</b>' : '') + '</p>';
    });
  }

  function mount() {
    [document.querySelector('cart-drawer-component'),
     document.querySelector('.cart-drawer'),
     document.querySelector('#cart-drawer'),
     document.querySelector('.cart__items'),
     document.querySelector('cart-items-component')]
    .filter(Boolean).forEach(function (t) {
      if (t.querySelector('[data-bv-bogo]')) return;
      var box = document.createElement('div');
      box.setAttribute('data-bv-bogo', '');
      box.className = 'bv-bogo';
      t.insertBefore(box, t.firstChild);
    });
  }

  function refresh() {
    mount();
    if (!document.querySelector('[data-bv-bogo]')) return;
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js')
      .then(function (r) { return r.json(); }).then(render).catch(function () {});
  }

  ['cart:update', 'cart:updated', 'cart:refresh', 'variant:add'].forEach(function (e) {
    document.addEventListener(e, refresh);
  });

  var of = window.fetch;
  window.fetch = function () {
    var u = arguments[0] && (arguments[0].url || arguments[0]);
    var isCart = typeof u === 'string' && /\/cart\/(add|change|update|clear)/.test(u);
    return of.apply(this, arguments).then(function (res) {
      if (isCart) setTimeout(refresh, 200);
      return res;
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
  document.addEventListener('shopify:section:load', refresh);
})();
